module.exports = __webpack_public_path__ + "img/4.fc07dd39.png";